import React from 'react'
import { Container, Header, Card, Icon, Label, Accordion, Image } from 'semantic-ui-react';
import _ from 'lodash'
import InitiativeCard from './BasicCard'
import NoInitiativeImage from '../../../../../images/grafix-banner/lifecycledesigner.svg';

var moment = require('moment');
class GroupedInitiativeCard extends React.Component {

    // In Design = 0,  Active  = 1,  Completed = 2, Closed = 3
    switchStatus = (number) => {
        switch (number) {
            case "-1":
                return "Draft"
            case "0":
                return "In Design"
            case "1":
                return "Active"
            case "2":
                return "Completed"
            case "3":
                return "Closed"
            case "4":
                return "Edit mode"
            case "5":
                return "Cancelled"
            default:
                return number
        }
    }

    render() {
        const { InitiativeLibrary, sortingFlag } = this.props;
        function sortByHeading(a, b) {

            let hA = a.heading.toUpperCase();
            let hB = b.heading.toUpperCase();
            let sA = a.sortBy && a.sortBy.toUpperCase();
            let sB = b.sortBy && b.sortBy.toUpperCase();

            if (sA < sB) {
                return -1;
            }
            else if (sA > sB) {
                return 1;
            }
            else {
                if (hA < hB) {
                    return -1;
                }
                else if (hA > hB) {
                    return 1;
                }
                return 0;
            }
        }

        var collator = new Intl.Collator(undefined, {
            numeric: true,
            sensitivity: 'base'
        });

        let pl = InitiativeLibrary && InitiativeLibrary.length !== 0 ?
            InitiativeLibrary
                .filter(f => { return !f.copyId && f.status!==6 })
                .sort((a, b) => {
                    return new Date(b.createdAt) - new Date(a.createdAt);
                }) : null
        let groupMe;
        if (sortingFlag.key === 'name') {
            groupMe = _(pl)
                .groupBy(o => o.name[0].toUpperCase())
        } else if (sortingFlag.key === 'baseCategory') {
            groupMe = _(pl)
                .groupBy(o => o.baseCategory._id)
        } else if (sortingFlag.key === 'category') {
            groupMe = _(pl)
                .groupBy(o => o.category._id)
        } else if (sortingFlag.key === 'subCategory') {
            groupMe = _(pl)
                .groupBy(o => o.subCategory && o.subCategory._id)
        } else if (sortingFlag.key === 'priority') {
            groupMe = _(pl)
                .groupBy(o => o.priority)
        } else if (sortingFlag.key === 'status') {
            groupMe = _(pl)
                .groupBy(o => o.combineActiveStatus);
        } else if (sortingFlag.key === 'playbook') {
            groupMe = _(pl)
                .groupBy(o => o.practiceId)
        } else if (sortingFlag.key === 'createdAt') {
            groupMe = _(pl)
                .groupBy(v => moment(v.createdAt).format('YYYY MMMM'))
        } else if (sortingFlag.key === 'updatedAt') {
            groupMe = _(pl)
                .groupBy(v => moment(v.updatedAt).format('YYYY MMMM'))
        } else {
            groupMe = _(pl)
                .groupBy(o => o.name[0].toUpperCase())
        }

        let value = groupMe
            .map((initiatives, heading) => ({ heading, initiatives }))
            .value();

        let groupedData = null;

        if (sortingFlag.key === 'subCategory') {
            value = groupMe
                .map((initiatives, heading) => ({ heading: heading, initiatives: initiatives, sortBy: initiatives[0].baseCategory.name }))
                .value();
            groupedData = sortingFlag.order === -1 ? value.sort(sortByHeading) : value.sort(sortByHeading).reverse();

        } else {
            value = groupMe
                .map((initiatives, heading) => ({ heading, initiatives }))
                .value();
            groupedData = sortingFlag.order === -1 ? value : value.reverse();
        }


        let panels = []
        for (let i = 0; i < groupedData.length; i++) {
            panels.push({
                key: i,
                title: {
                    content: (
                        <span>
                            {sortingFlag.key === 'status' ?
                                this.switchStatus(groupedData[i].heading) :
                                sortingFlag.key === 'subCategory' ?
                                    <span>
                                        {groupedData[i].initiatives[0].baseCategory ? groupedData[i].initiatives[0].baseCategory.name : ""} <Icon name="chevron right" />
                                        {groupedData[i].initiatives[0].category ? groupedData[i].initiatives[0].category.name : ""} <Icon name="chevron right" />
                                        {groupedData[i].initiatives[0].subCategory ? groupedData[i].initiatives[0].subCategory.name : ""}
                                    </span> :
                                    groupedData[i].heading.length !== 0 ? groupedData[i].heading : "Others"} &nbsp;&nbsp;
                            <Label size="mini" >
                                {groupedData[i].initiatives.length}
                            </Label>
                        </span>
                    ),
                },
                content: {
                    content: <p>
                        <Card.Group className="playbookCardsList" >
                            {groupedData[i].initiatives && groupedData[i].initiatives.map((item, index) => {
                                return <InitiativeCard
                                    key={index}
                                    index={index}
                                    cardData={item}
                                    id={item._id}
                                    selectedDataById={this.props.selectedDataById}
                                    routeParams={this.props.routeParams}
                                />
                            })}
                        </Card.Group>
                    </p>
                }
            })
        }

        return (
            //*************For accordian View*************
            <div>
                <Accordion
                    defaultActiveIndex={[0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10]}
                    panels={panels}
                    exclusive={false}
                    fluid
                    className="groupingCards"
                />

                {groupedData && groupedData.length === 0 ?
                    <Container fluid className="pad_40">
                        <Image src={NoInitiativeImage} className="landingImage" size='large' centered={true} style={{ width: "300px" }} />
                        <Header as='h3' icon textAlign='center'>
                            <Header.Content >
                                No Initiative to display
                                <br /> <br /> <br />
                            </Header.Content>

                        </Header>
                    </Container> : null}
            </div>
            //*************For Normal View*****************
            // groupedData && groupedData.length !== 0 && groupedData.map((a, i) => {
            //   //   return <div className="w_100">
            //     <Header as='h6' dividing>
            //         {sortingFlag.key === 'status' ?
            //             this.switchStatus(a.heading) :
            //             sortingFlag.key === 'category' ?
            //                 <span>
            //                     {a.initiatives[0].baseCategory} <Icon name="chevron right" />
            //                     {a.initiatives[0].category} <Icon name="chevron right" />
            //                     {a.initiatives[0].subCategory}
            //                 </span> :
            //                 a.heading.length !== 0 ? a.heading : "Others"}
            //     </Header>
            //     <Card.Group className="playbookCardsList" >
            //         {a.initiatives.map((PracticeLibrary, index) => {
            //             return <LibraryCard
            //                 id={PracticeLibrary._id}
            //                 key={index}
            //                 index={index}
            //                 PracticeLibrary={PracticeLibrary}
            //                 clickIndex={this.props.libraryCardIndex}
            //                 selectedPracticeLibrary={this.props.selectedPracticeLibrary}
            //                 selectedCardLoader={this.props.selectedCardLoader} />
            //         })}
            //     </Card.Group> <br /><br />
            // </div>
            //})
        )
    }
}

export default GroupedInitiativeCard;